export default __webpack_public_path__ + "static/media/francetv-black.e095cb7f.svg";